import { getEnv } from "@/hooks/useEnv";

export const BACKEND_URL = getEnv("VITE_BACKEND_URL") ?? "";
export const BACKEND_URL_TRAILED = BACKEND_URL.endsWith("/") ? BACKEND_URL : `${BACKEND_URL}/`;
export const BACKEND_API_PATH = "api/internal";
export const BACKEND_PUBLIC_API_PATH = "api/public";
export const BACKEND_API_URL = `${BACKEND_URL_TRAILED}${BACKEND_API_PATH}`;
